import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observable, action } from 'mobx'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Loader from '../../shared/components/Loader'
import ErrorContainer from '../../shared/containers/Error'
import FormPage from '../components/FormPage'
import MessageHistory from '../../message/containers/MessageHistory'
import syncTransaction from '../../shared/syncTransaction'

import GeocodeAddressService from '../../shared/services/GeocodeAddress'
import GoogleMapsGeocoderProxy from '../../shared/services/GoogleMapsGeocoderProxy'
import GoogleMapsApiLoader from '../../shared/libs/google-maps-api-loader'

const INITIAL_MESSAGE = (
  <div>
    Zur Zeit gibt es noch keinen Nachrichtenverlauf für dieses Museum.
    <br />
    <br />
    Nachdem das Museum gespeichert wurde, wird es einem Administrator zur
    Überprüfung übergeben. Der sämtliche Freigabe-Velauf kann danach in dieser
    Nachrichtenhistorie nachvollzogen werden.
    <br />
    <br />
    Auch Details warum ein Administrator eine Änderung u.U. abgelehnt hat, kann
    dieser Historie entnommen werden.
  </div>
)

@inject('auth', 'museum')
@observer
class FormContainer extends Component {
  /* eslint-disable react/sort-comp */
  @observable isSaving = null;

  @observable error = null;

  @observable geocoder = null;
  /* eslint-enable react/sort-comp */

  static propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    museum: PropTypes.object.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string
    }),
    router: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired
  };

  constructor(props) {
    super(props)
    this.load(props)

    this.cancelPromise = false
  }

  componentWillUnmount() {
    this.cancelPromise = true
  }

  componentWillMount() {
    this.geocoder = 'loading'
    GoogleMapsApiLoader.load({
      key: window.APP_CONFIG.apis.gmaps.key
      // sensor: window.APP_CONFIG.apis.gmaps.sensor
    })
      .then((api) => {
        this.geocoder = new GeocodeAddressService(new GoogleMapsGeocoderProxy(api))
      })
      .catch((err) => {
        this.geocoder = err
      })
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  @autobind
  handleClose() {
    // On close go back to startpage as defined in #65
    this.props.router.push('/')
  }

  @autobind
  handleDelete(model) {
    const method = this.props.auth.acs.isAuthorized('SUPERADMIN,ADMIN')
        || model.isDeactivated
      ? 'destroy'
      : 'deactivate'
    return this:: syncTransaction(model[method]())
  }

  @autobind
  handleActivate(model) {
    return this:: syncTransaction(model.activate())
  }

  @autobind
  handleSave(model) {
    return this:: syncTransaction(model.save())
  }

  @action
  resolveError() {
    this.error = null
  }

  load({ auth, museum, params: { id } }) {
    if (!id) {
      museum.setCurrent(museum.createModel({
        museumId: auth.user.museumId
      }))
    }
    else {
      museum.openById(id)
    }
  }

  render() {
    const {
      museum,
      museum: { current },
      params: { id }
    } = this.props

    if (museum.loading) {
      return <Loader>Daten werden geladen</Loader>
    }

    if (this.geocoder === 'loading') {
      return <Loader>Geocoder wird geladen</Loader>
    }

    if (!current || (current.id && current.id !== id * 1)) {
      return <ErrorContainer>Fehler beim Laden</ErrorContainer>
    }

    const canDelete = current.isDeactivated
      || this.props.auth.acs.isAuthorized('SUPERADMIN,ADMIN')

    return (
      <div className="horizontal">
        <ErrorContainer className="error-layer" causingComponent={this} />

        <FormPage
          current={current}
          canDelete={canDelete}
          onClose={this.handleClose}
          onDelete={this.handleDelete}
          onActivate={this.handleActivate}
          onSave={this.handleSave}
          isBusy={this.isSaving}
          geocoder={this.geocoder}
        />

        <MessageHistory
          type="museum"
          id={id * 1}
          initialMessage={INITIAL_MESSAGE}
        />
      </div>
    )
  }
}

const FormContainerWithRouter = withRouter(FormContainer)

export { FormContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/museum/containers/Form.js